import {Button, Lead, Modal, Slot, Text, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import React, {memo, useCallback} from 'react'
import {useFormContext} from 'react-hook-form'

import {useActionContext} from '../../../../contexts'
import type {OrderFormState} from '../../../../types'
import type {ActionComponentProps} from '../../../types'
import * as classes from './classes'
import type {WhatsNextModalProps} from './types'

export const WhatsNextModalUI: React.FC<WhatsNextModalProps> = props => {
  const {handleClose, isActive} = props
  const i18n = useI18n()

  return (
    <Modal className={classes.root} data-e2e="whats-next-modal" onClose={handleClose} opened={isActive}>
      <Modal.Header
        renderTitle={(a11yProps, typographyProps) => (
          <Typography group="tight" id={a11yProps.id} mt="s" thickness="medium" variant="title4">
            {typographyProps.children}
          </Typography>
        )}
        title={i18n('modal.whats-next.title', 'Заказ оформлен! Что дальше')}
      />

      <Modal.Body>
        <div className={classes.slotWrapper}>
          <Slot size="l">
            <Lead>
              <div className={classes.iconSpot}>
                <Typography group="normal" thickness="medium" variant="title4">
                  1
                </Typography>
              </div>
            </Lead>

            <Text>
              <Typography group="tight" pb="xs" thickness="bold" variant="body2">
                {i18n('modal.whats-next.description-one.title', 'Отнесите посылку в пункт')}
              </Typography>

              <Typography group="tight" thickness="regular" variant="caption1">
                {i18n(
                  'modal.whats-next.description-one.subtitle',
                  'Упаковывать не нужно: это сделает сотрудник пункта',
                )}
              </Typography>
            </Text>
          </Slot>
        </div>

        <div className={classes.slotWrapper}>
          <Slot size="l">
            <Lead>
              <div className={classes.iconSpot}>
                <Typography group="normal" thickness="medium" variant="title4">
                  2
                </Typography>
              </div>
            </Lead>

            <Text>
              <Typography group="tight" pb="xs" thickness="bold" variant="body2">
                {i18n(
                  'modal.whats-next.description-two.title',
                  'Отправителю и получателю придёт ссылка на отслеживание',
                )}
              </Typography>

              <Typography group="tight" thickness="regular" variant="caption1">
                {i18n('modal.whats-next.description-two.subtitle', 'Там же будут номер заказа и адреса пунктов')}
              </Typography>
            </Text>
          </Slot>
        </div>
      </Modal.Body>

      <Modal.Footer p="s">
        <Button data-e2e="account-registration" onClick={handleClose} variant="action" fullWidth>
          {i18n('modal.whats-next.button.confirm', 'Понятно')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export const WhatsNextModal = memo<ActionComponentProps>(props => {
  const {isActive, setActive} = props
  const {handleSubmit} = useFormContext<OrderFormState>()
  const {onSubmit} = useActionContext()

  const handleClose = useCallback(() => {
    void handleSubmit(data => {
      setActive?.(false)
      onSubmit(data)
    })()
  }, [handleSubmit, onSubmit, setActive])

  return <WhatsNextModalUI handleClose={handleClose} isActive={isActive} />
})

WhatsNextModal.displayName = 'WhatsNextModal'
